"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["styleType", "children"];

var _this = void 0;

var StyleType = ["processing", "success", "warning", "error", "stopped", "loading"];
/**
 * State
 * @description 资源状态展示
 */

var State = function State(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var styleType = _ref.styleType,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderDot = function renderDot() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (StyleType.indexOf(styleType) < 0) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style.dotWrapperCls
    }, /*#__PURE__*/_react["default"].createElement(_style.StyledDot, {
      styleType: styleType
    }));
  }.bind(this);

  var renderLoadingIcon = function renderLoadingIcon() {
    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_style.StyledIcon, {
      type: "loading2",
      spin: true
    });
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_style.StyledWrapper, others, styleType === "loading" ? renderLoadingIcon() : renderDot(), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style.contentCls
  }, children));
}.bind(void 0);

State.propTypes = {
  /** 状态类型 */
  styleType: _propTypes["default"].oneOf(StyleType),

  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  children: _propTypes["default"].node
};
State.defaultProps = {};
var _default = State;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/State/State.js
// module id = 2163
// module chunks = 6 7 17 18